var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavicon15(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18417_7208)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.502 10.2501V8.73427H14.4978C14.4682 7.9845 14.3091 7.2717 14.0363 6.62305C16.7886 6.6781 19.0027 8.92634 19.0027 11.6917C19.0027 14.4917 16.7329 16.7614 13.933 16.7614H7.41475C7.51111 16.7614 7.60749 16.758 7.70378 16.7511H8.00103C11.5914 16.7511 14.502 13.8405 14.502 10.2501Z",
    fill: "#7A67FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M14.502 8.73323V10.2491C14.502 13.8395 11.5914 16.75 8.00103 16.75H6.49232C3.45902 16.75 1 14.4832 1 11.6868C1 10.017 1.87679 8.53603 3.22908 7.61373C3.87906 5.10961 5.86527 3.24805 8.78082 3.24805C12.1167 3.24805 14.3775 5.68507 14.4978 8.73323H14.502Z",
    fill: "url(#paint0_linear_18417_7208)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 11C3 12.1667 3.8 14.6 7 15",
    stroke: "white",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18417_7208",
    x1: 1,
    y1: 9.99905,
    x2: 14.502,
    y2: 9.99905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C082FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7967FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18417_7208"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(1 1)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavicon15);
export default __webpack_public_path__ + "static/media/navicon15.302155df4071609f1f756c72eed9a6d4.svg";
export { ForwardRef as ReactComponent };